"use client";

import * as React from "react";
import { Stack, Box, Typography } from "@mui/material";
import {ColletteButton} from "@collette-travel/collette-common-controls";

type TertiaryPaneHeaderProps = {
  tertiaryHeaderLabel: string;
  tertiaryHeaderLearnMoreUrl: string;
  tertiaryHeaderViewAllDestinationsUrl: string;
};
export default function TertiaryPaneHeader(props: TertiaryPaneHeaderProps) {
  const { tertiaryHeaderLabel, tertiaryHeaderLearnMoreUrl, tertiaryHeaderViewAllDestinationsUrl } =
    props;

  return (
    <Stack
      direction="row"
      sx={{
        justifyContent: "space-between",
        pt: 3,
        pl: 4,
        pb: 2,
        boxShadow: 8
      }}
    >
      <Stack direction="row" spacing={2} pl={1} sx={{ alignItems: "center" }}>
        <Typography
          sx={{ padding: 0, minHeight: "25px", fontWeight: 600, fontSize: "2rem" }}
          component="div"
        >
          {tertiaryHeaderLabel}
        </Typography>
      </Stack>
      <Stack direction="row" spacing={2} sx={{ alignItems: "center", pr: 2 }}>
        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          {tertiaryHeaderLearnMoreUrl !== undefined && (
            <ColletteButton
              component="a"
              href={tertiaryHeaderLearnMoreUrl}
              variant="outlined"
              testId="learn-more-button"
              label="Learn More"
              size="large"
            />
          )}
          {tertiaryHeaderViewAllDestinationsUrl !== undefined && (
            <ColletteButton
              component="a"
              href={tertiaryHeaderViewAllDestinationsUrl}
              color="secondary"
              testId="view-all-tours-button"
              label="View All Tours"
              size="large"
            />
          )}
        </Box>
      </Stack>
    </Stack>
  );
}
